import {
  formatUsPhoneInput,
  isValidEmail,
  isValidUsPhone,
  normalizePhone,
} from '@galapagos/shared/registration';

/** The eligibility request's limit on each name part. */
export const LEGAL_NAME_MAX_LENGTH = 120;

export type LegalNameProblem = 'missing' | 'tooLong';

/** Why a trimmed name part cannot be submitted, or null when it can. */
export function legalNameProblem(trimmed: string): LegalNameProblem | null {
  if (trimmed === '') return 'missing';
  if (trimmed.length > LEGAL_NAME_MAX_LENGTH) return 'tooLong';
  return null;
}

/** The E.164 number for a US phone field's digits, or null when it is not a valid US number. */
export function usPhoneDestination(digits: string): string | null {
  return isValidUsPhone(digits) ? normalizePhone(digits) : null;
}

/** A US E.164 number as members read it, e.g. `+1 (202) 555-0143`. */
export function phoneDisplay(destination: string): string {
  return `+1 ${formatUsPhoneInput(destination)}`;
}

/** The email as it is sent and stored: trimmed and lowercased. */
export function normalizedEmail(raw: string): string {
  return raw.trim().toLowerCase();
}

export function isUsableEmail(raw: string): boolean {
  return isValidEmail(normalizedEmail(raw));
}
